import { render } from "./WordCountWidget.vue?vue&type=template&id=43342927"
import script from "./WordCountWidget.vue?vue&type=script&lang=js"
export * from "./WordCountWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__